import { render } from "./QuizDrawerRulesPanel.vue?vue&type=template&id=230116da&scoped=true"
import script from "./QuizDrawerRulesPanel.vue?vue&type=script&lang=js"
export * from "./QuizDrawerRulesPanel.vue?vue&type=script&lang=js"

import "./QuizDrawerRulesPanel.vue?vue&type=style&index=0&id=230116da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230116da"]])

export default __exports__